import React from 'react'

import DTICalculator from '@cred/react-dti-calculator/DTICalculator'

import WidgetPage from 'components/hocs/widget-page'

const DTICalculatorApp = () => {
  return <DTICalculator />
}

export { DTICalculatorApp }

export default WidgetPage(DTICalculatorApp)
